import { useContext, useMemo } from 'react';
import TableContext from '../TableContext';

const ColumnFilterEvaluator = ({ data, children }) => {
  const { columnFilters } = useContext(TableContext);

  const dataMatchingFilters = useMemo(() => {
    let result = data;
    columnFilters
      .filter(({ values }) => values.length > 0)
      .forEach(({ columnName, values: filterOnValues }) => {
        result = result.filter(
          row =>
            filterOnValues.some(filter => {
              // added to make published filter
              if (columnName == 'status' || columnName == 'globalPpsiStatus') {
                return row[columnName] === filter;
              }
              return row[columnName].includes(filter);
            })
          // filterOnValues.some(filter => row[columnName] == filter)
        );
      });

    return result;
  }, [data, columnFilters]);

  return children(dataMatchingFilters);
};

export default ColumnFilterEvaluator;
